import React from "react";
import { Wrapper } from "./style";
import Com1 from "./components/Com1";
import Com2 from "./components/Com2";
import Com3 from "./components/Pagination";
import DesignCom from "./components/DesignCom";
import { useParams } from "react-router";
import Pagination from "./components/Pagination";
import { useQuery } from "react-query";
import { axiosInstance } from "api";
import Loading from "components/Loading";
const SupportDetail = () => {
  const { supportId, menuIndex } = useParams();
  const {
    data: menu,
    isSuccess: menuSuccess,
    isLoading: menuLoading,
  } = useQuery(["support_menu" + supportId], () => axiosInstance.get("/supportMenu/" + supportId));

  const {
    data: menuData,
    isSuccess: DataSuccess,
    isLoading: DataLoading,
  } = useQuery(["support_menu_data" + menuIndex], () =>
    axiosInstance.get("/supportMenuData/" + supportId + "/" + menuIndex),
  );

  if (menuLoading || DataLoading) return <Loading />;
  return (
    <>
      {menuSuccess && DataSuccess && (
        <Wrapper>
          <Com1 menu={menu} />
          <Com2 menu={menu} menuData={menuData} />
          <Pagination />
          <DesignCom />
        </Wrapper>
      )}
    </>
  );
};

export default SupportDetail;
